import React, { useEffect, useState } from 'react';
import API from '../../config/axios';
import { toastErrorMessage } from '../../utils/utils';
import { api_paths } from '../../config/api.paths';
import { SET_LOADING } from '../../redux/user';
import { useDispatch } from 'react-redux';

const TermsAndConditions = () => {
  const [page, setPage] = useState()
  const dispatch = useDispatch();

  const getPageDetails = async (identifier) => {
    dispatch(SET_LOADING(true));
    try {
      const response = await API.get(`${api_paths.GET_CMS_PAGE}${identifier}`)
      if (response?.data?.payload?.result) {
        setPage(response?.data?.payload?.result)
      }

    } catch (error) {
      console.log(error);
      toastErrorMessage(error?.response?.data?.message);
    }
    dispatch(SET_LOADING(false));
  }

  useEffect(() => {
    getPageDetails('TERM_CONDITION') // privacy_policy term_condition about_us
    //eslint-disable-next-line
  }, [])

  return (
    <div
      className='cms_pages'
      style={{ background: '#ffffff', padding: '2rem' }}
      dangerouslySetInnerHTML={{ __html: page?.content }}
    ></div>
  )
}

export default TermsAndConditions
